var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 47 46.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_163_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.595,2.137c0-1.18-0.957-2.137-2.136-2.137H5.074c-1.18,0-2.136,0.957-2.136,2.137c0,0.789,0.432,1.47,1.068,1.84 v24.608c0.578-0.528,1.281-1.171,2.136-1.953V4.273H41.39v23.499H13.861c-0.715,0.781-1.368,1.496-1.954,2.138h1.885 L9.952,44.312c-0.304,1.14,0.374,2.311,1.514,2.614c1.134,0.302,2.31-0.374,2.614-1.514l3.85-14.437h11.671l3.851,14.437 c0.255,0.955,1.118,1.586,2.062,1.586c0.184,0,0.368-0.022,0.552-0.072c1.141-0.305,1.818-1.476,1.515-2.614L33.74,29.909h8.72 c0.59,0,1.067-0.478,1.067-1.068V3.977C44.164,3.606,44.595,2.926,44.595,2.137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.369,23.768v-8.011c0-1.18-0.957-2.137-2.136-2.137c-1.179,0-2.136,0.957-2.136,2.137v8.011 c0,1.182,0.957,2.138,2.136,2.138C24.412,25.905,25.369,24.948,25.369,23.768z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.312,23.768V8.278c0-1.18-0.957-2.136-2.137-2.136S28.04,7.098,28.04,8.278v15.49c0,1.181,0.957,2.137,2.136,2.137 C31.355,25.904,32.312,24.948,32.312,23.768z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.254,23.768V12.551c0-1.181-0.957-2.137-2.136-2.137c-1.18,0-2.137,0.956-2.137,2.137v11.217 c0,1.182,0.957,2.138,2.137,2.138C38.297,25.905,39.254,24.948,39.254,23.768z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.917,19.435c-0.203-0.202-0.534-0.203-0.737,0c0,0-14.3,13.073-14.369,13.142c-0.542,0.542-0.542,1.422,0,1.965 c0.543,0.543,1.423,0.543,1.965,0c0.069-0.067,13.141-14.368,13.141-14.368C18.121,19.969,18.12,19.639,17.917,19.435z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/board.891214c3e1640ef194d71d83447a44f0.svg";
export { ForwardRef as ReactComponent };